import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DesignModule } from '../design/design.module';

import { CifValidatorService } from './services/cif-validator.service';
import { MailValidatorService } from './services/mail-validator.service';
import { PhoneValidatorService } from './services/phone-validator.service';
import { ZipCodeValidatorService } from './services/zip-code-validator.service';

import { AsteriskDirective } from './directives/asterisk.directive';

@NgModule({

    declarations: [
        AsteriskDirective
    ],

    imports: [
        CommonModule,
        HttpClientModule,
        HttpClientJsonpModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        DesignModule
    ],

    exports: [
        CommonModule,
        HttpClientModule,
        HttpClientJsonpModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        DesignModule,
        AsteriskDirective
    ],

    providers: [
        DatePipe,
        CifValidatorService,
        MailValidatorService,
        PhoneValidatorService,
        ZipCodeValidatorService
    ],

})

export class SharedModule {}
